export default [
  {key: 'wage', label: '固薪'},
  {key: 'commission', label: '提成'},
  {key: 'income_tax', label: '个税'},
  {key: 'subsidy', label: '餐补'},
  {key: 'endowment_insurance', label: '养老'},
  {key: 'medical_insurance', label: '医保'},
  {key: 'maternity_insurance', label: '生育'},
  {key: 'unemployment_insurance', label: '失业'},
  {key: 'employment_injury_insurance', label: '工伤'},
  {key: 'critical_illness_insurance', label: '大病'},
  {key: 'housing_fund', label: '住房公积金'},
  // {key: 'year_end_bonus', label: '十五薪'},
  {key: 'performance_bonus', label: '绩效奖金'},
  // {key: 'dividend_bonus', label: '分红奖金'},
  // {key: 'other_bonus', label: '其他奖金'},
  {key: 'severance_package', label: '离职补偿'},
  {key: 'recommend_award', label: '推荐奖'},
  // {key: 'intern_wage', label: '实习生津贴'},
  // {key: 'intern_subsidy', label: '实习生餐补'},
  // {key: 'intern_tax', label: '实习生个税'},
]
